import React from "react";
import { LogIn, AlertTriangle } from "lucide-react";

export const isOddHour = (d) => { if (!d) return false; const h = new Date(d).getHours(); return h >= 22 || h < 6; };
const ago = (d) => {
  if (!d) return "Belum pernah login";
  const m = Math.round((Date.now() - new Date(d).getTime()) / 60000);
  if (m < 60) return `${Math.max(m, 0)} menit lalu`;
  if (m < 1440) return `${Math.round(m / 60)} jam lalu`;
  return `${Math.round(m / 1440)} hari lalu`;
};
const fmt = (d) => new Date(d).toLocaleString("id-ID", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });

function flag(s) {
  if (s.disabled && s.last_login_at) return "Akun nonaktif";
  if (isOddHour(s.last_login_at)) return "Jam tak wajar (22.00–06.00)";
  return null;
}

export function StaffLogins({ staff, roleName }) {
  if (!staff.length) return null;
  const list = [...staff].sort((a, b) => (b.last_login_at || "").localeCompare(a.last_login_at || ""));
  const flagged = list.filter(flag).length;
  return (
    <section className="mt-5 aivora-card p-4" data-testid="staff-logins">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <p className="flex items-center gap-2 text-sm font-bold text-slate-900"><LogIn size={15} className="text-brand" /> Login terakhir staf</p>
        {flagged > 0 ? <span className="inline-flex items-center gap-1 rounded-full bg-rose-50 px-2.5 py-1 text-[11px] font-bold text-rose-700" data-testid="staff-logins-flagged"><AlertTriangle size={12} /> {flagged} perlu dicek</span>
          : <span className="text-[11px] text-slate-400">Tidak ada login mencurigakan</span>}
      </div>
      <ul className="mt-3 grid gap-2 sm:grid-cols-2 xl:grid-cols-3">
        {list.map((s) => {
          const f = flag(s);
          return (
            <li key={s.id} className={`rounded-xl border px-3 py-2.5 ${f ? "border-rose-200 bg-rose-50/60" : "border-line bg-white"}`} data-testid={`staff-login-${s.id}`}>
              <p className="flex items-center gap-1.5 truncate text-xs font-bold text-slate-800">{s.name || s.email}
                <span className="rounded bg-slate-100 px-1.5 py-0.5 text-[10px] font-semibold text-slate-500">{roleName(s.platform_role)}</span>
                {s.disabled && <span className="rounded bg-slate-200 px-1.5 py-0.5 text-[10px] font-semibold text-slate-600">nonaktif</span>}</p>
              <p className="mt-0.5 truncate text-[11px] text-slate-500">{s.email}</p>
              <p className={`mt-1 text-[11px] ${f ? "font-semibold text-rose-700" : "text-slate-400"}`} data-testid={`staff-login-time-${s.id}`}>
                {s.last_login_at ? `${fmt(s.last_login_at)} · ${ago(s.last_login_at)}` : ago(null)}{f ? ` · ${f}` : ""}
              </p>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
